import { createAxiosInstance } from "./index";
import hostConfig from "@/config/hostResolver";

const baseUrl = process.env.VUE_APP_BADGE_URL ?? `${hostConfig.apiBaseUrl}/badge-service`;

class BadgeService {
  constructor() {
    this.apiClient = createAxiosInstance(baseUrl);
  }

  // V3 routes
  async getBadges(params) {
    return (await this.apiClient.get(baseUrl + "/v3/badge", { params }))?.data;
  } // getBadges

  async getBadge(badgeId) {
    return (await this.apiClient.get(baseUrl + "/v3/badge/" + badgeId))?.data;
  } // getBadge

  async createBadge(data, params = {}) {
    return (await this.apiClient.post(baseUrl + "/v3/badge", data, { params }))?.data;
  } // createBadge

  async updateBadge(badgeId, data) {
    return (await this.apiClient.patch(baseUrl + "/v3/badge/" + badgeId, data))?.data;
  } // updateBadge

  async deleteBadge(badgeId) {
    return (await this.apiClient.delete(baseUrl + "/v3/badge/" + badgeId))?.data;
  } // deleteBadge

  async uploadBadgeImage(badgeId, imageType, clientId, imageFile) {
    let formData = new FormData();
    formData.append("clientId", clientId);
    formData.append("file", imageFile);

    return (
      await this.apiClient.post(baseUrl + `/v3/badge/upload/${imageType}/${badgeId}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
    )?.data;
  } // uploadBadgeImage

  async deleteBadgeImage(badgeId, imageType) {
    return (await this.apiClient.delete(baseUrl + `/v3/badge/upload/${imageType}/${badgeId}`))
      ?.data;
  } // deleteBadgeImage

  async createUserBadge(data) {
    return (await this.apiClient.post(baseUrl + "/v3/user-badge", data))?.data;
  } // createUserBadge

  async getUserBadgesForUser(userId, params = {}) {
    return (
      await this.apiClient.get(baseUrl + "/v3/user-badge/user/" + userId, {
        params,
      })
    )?.data;
  } // getUserBadgesForUser
}

export default BadgeService;
